import { render, staticRenderFns } from "./CrudSelect.vue?vue&type=template&id=8d1ff280"
import script from "./CrudSelect.vue?vue&type=script&lang=js"
export * from "./CrudSelect.vue?vue&type=script&lang=js"
import style0 from "./CrudSelect.vue?vue&type=style&index=0&id=8d1ff280&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports